GrouponValidate = require "../../../../../groupon/frontend/validate"
SupportEmailDescriptionTemplate = require '../../../../email_description.html.mustache'
Backbone = require 'backbone'
Backbone.$ = $

class EmailFormUSEmailDescriptionView extends Backbone.View

  events:
    'customEvent .description': 'validateEmailForm'
    'keyup .description': 'validateEmailForm'

  initialize: (options) ->
    @options = options || {}
    @I18nScope = 'modules.support'
    @isInputFieldEmpty = true
    @elementID = ".description"
    @template = SupportEmailDescriptionTemplate
    @model = @options.model
    @label = I18n.t("js.modules.support.whatson")
    @isInputCompulsory = @model.required

  render: ->
    @$el.html(toHtml(@template, @toHash()))

  toHash: ->
    flexibleStepThree = Groupon.Support.ContentModel.flexibleStepThree
    placeholderText: flexibleStepThree?.attributes?.description?.placeHolder

  isInputGiven: ->
    @$el.find(@elementID).val().trim().length > 0

  readInput: ->
    @$el.find(@elementID).val().trim()

  isInputValid: ->
    @validateDescription()

  validateEmailForm: ->
    if @isInputCompulsory && ((@isInputFieldEmpty && @isInputGiven()) || !(@isInputFieldEmpty || @isInputGiven()))
      @isInputFieldEmpty = !@isInputGiven()
      @options.validateEmailForm()

  populateInput: (data)->
    if @isInputGiven()
      inputData = @readInput()
      data.description += "\n\n #{@label} : #{inputData}"

  creditElement: ->
    @$el.find('.credit_card_warning')

  validateDescription: ->
    isCreditInformation = GrouponValidate.creditCard(@readInput())
    if isCreditInformation
      @creditElement().css('display','block')
    else
      @creditElement().css('display','none')
    !isCreditInformation

module.exports = EmailFormUSEmailDescriptionView
